import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { InputMain, ModalActions } from "components";
import { Svg } from "assets";
import {
  authActions,
  httpRequestsOnErrorsActions,
  httpRequestsOnSuccessActions,
} from "store";
import { FindError, FindSuccess, Notify } from "utils";
import { ACTION_TYPE_CHANGE_PASSWORD } from "./constants";

export const ChangePassword = ({ handleCancel }) => {
  const dispatch = useDispatch();
  const { handleSubmit, control, setError, reset, clearErrors } = useForm({});
  const success = FindSuccess(ACTION_TYPE_CHANGE_PASSWORD);
  const backError = FindError(ACTION_TYPE_CHANGE_PASSWORD);

  useEffect(() => {
    if (success?.type) {
      dispatch(
        httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE_CHANGE_PASSWORD)
      );
      reset({
        password: "",
        newPassword: "",
        confirmation: "",
      });
      Notify("Profile Updated Successfully");
    }
  }, [success]);

  useEffect(() => {
    if (backError?.error === "User password does not match") {
      setError("password", {
        type: "required",
        message: "User password does not match",
      });
      dispatch(
        httpRequestsOnErrorsActions.removeError(ACTION_TYPE_CHANGE_PASSWORD)
      );
    }
  }, [backError]);

  const handleReset = (e) => {
    clearErrors();
    if (handleCancel) handleCancel(e, reset);
  };

  const onSubmit = (data) => {
    if (data?.newPassword === data?.confirmation) {
      dispatch(authActions.changePassword(data));
    } else {
      setError("confirmation", {
        type: "required",
        message: "New Password does not match with the confirmation",
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <InputMain
        name="password"
        type="password"
        control={control}
        placeholder="Write Old Password"
        labelHeader="Current Password"
        rules={{
          required: "This Field is required",
        }}
        startAdornment={<Svg.Lock />}
      />
      <InputMain
        name="newPassword"
        type="password"
        control={control}
        placeholder="Write New Password"
        labelHeader="New Password"
        rules={{
          required: "This Field is required",
        }}
        startAdornment={<Svg.Lock />}
      />
      <InputMain
        name="confirmation"
        type="password"
        control={control}
        placeholder="Confirm New Password"
        labelHeader="Confirm New Password"
        rules={{
          required: "This Field is required",
        }}
        startAdornment={<Svg.Lock />}
      />

      <ModalActions
        closeFunction={handleReset}
        defaultStyle={true}
        type="submit"
        loadAction={ACTION_TYPE_CHANGE_PASSWORD}
        saveTitle="Save"
      />
    </form>
  );
};
